import React, {useMemo, useState} from 'react';

import styles from './SearchByPlateNumber.module.css';
import {Input} from "../../ui/DataEntry/Input/Input.tsx";
import {Button} from "../../ui/General/Button/Button.tsx";
import {useScreenDetector} from "../../hooks/useScreenDetector.ts";
import {cn} from "../../utils/cn.ts";
import { API_URL } from '../../config.tsx';

interface Props {
    title?: string
    btnCssClass?: string
    inputsCssClass?: string
}

export const SearchByPlateNumber: React.FC<Props> = ({btnCssClass, inputsCssClass, title}) => {
    const {isMobile, isDesktop} = useScreenDetector();
    const [carNumber, setCarNumber] = useState<string>('');
    const [carNumberRegion, setCarNumberRegion] = useState<string>('');
    const [partName, setPartName] = useState<string>('');
    const [failedSearch, setFailedSearch] = useState<boolean>(false);

    const handleChangeInput = (inputField: string, value: string) => {
        setFailedSearch(false);
        if(inputField === 'carNumber') setCarNumber(value);
        if(inputField === 'carNumberRegion') setCarNumberRegion(value);
        if(inputField === 'partName') setPartName(value);
    }

    const defaultTitle = useMemo(() => {
        if (title) {
            return title;
        }

        if (isMobile) {
            return 'Поиск по госномеру'
        }

        if (isDesktop) {
            return 'Введите госномер'
        }

    }, [title]);

    const findSearchVehicleByCarNumber = (carNumber: string, carNumberRegion: string) => {
        fetch(`${API_URL}/find_by_car_number?number=${carNumber}&region=${carNumberRegion}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => {
                if (response.status === 404) {
                    setFailedSearch(true);
                    throw new Error('Not Found');
                }
                return response.json();
            })
            .then(vehicle => {
                if (vehicle.vehicle && Object.keys(vehicle.vehicle).length > 0) {
                    document.location = partName ? `/search-vehicle-with-name?carNumber=${carNumber}&carNumberRegion=${carNumberRegion}&partName=${partName}` : `/search-vehicle?carNumber=${carNumber}&carNumberRegion=${carNumberRegion}`;
                } else {
                    setFailedSearch(true);
                }
            })
    };

    return (
        <div className={styles.container}>
            {
                isDesktop ?
                    <>
                        <div>
                            <div className={styles.title}>{defaultTitle}</div>
                            <div className={cn(styles.inputs, inputsCssClass)} style={{marginTop: 8,}}>
                                <Input
                                    className={styles.input}
                                    placeholder='A 123 AA'
                                    value={carNumber}
                                    changeStateValue={value => handleChangeInput('carNumber', value)}
                                />
                                <Input
                                    className={styles.input}
                                    placeholder='125 RUS'
                                    value={carNumberRegion}
                                    changeStateValue={value => handleChangeInput('carNumberRegion', value)}
                                />
                                <Input
                                    className={styles.input}
                                    placeholder='Наименование запчасти'
                                    value={partName}
                                    changeStateValue={value => handleChangeInput('partName', value)}
                                />
                                <Button className={btnCssClass} type='search' id='search-car-by-car-number-btn'
                                        onClick={() => findSearchVehicleByCarNumber(carNumber, carNumberRegion)}/>
                            </div>
                            {failedSearch && (
                                <div className={styles.invalidInputText}>
                                    <div>X Госномер не найден.</div>
                                </div>
                            )}
                        </div>
                    </>
                    : null
            }
            {
                isMobile
                    ? <>
                        <div>
                            <h2 className={styles.title}>{defaultTitle}</h2>
                            <div className={cn(styles.inputs, inputsCssClass)}>
                                <Input
                                    wrapperStyle={{width: '50%'}}
                                    className={styles.input}
                                    placeholder='A 123 AA'
                                    value={carNumber}
                                    changeStateValue={value => handleChangeInput('carNumber', value)}
                                    style={{width: '100%'}}
                                />
                                <Input
                                    wrapperStyle={{width: '50%'}}
                                    className={styles.lastInput}
                                    placeholder='125 RUS'
                                    value={carNumberRegion}
                                    changeStateValue={value => handleChangeInput('carNumberRegion', value)}
                                    style={{width: '100%'}}
                                />
                            </div>
                            <div className={cn(styles.inputs, inputsCssClass)} style={{marginTop: 8,}}>
                                <Input
                                    wrapperStyle={{marginRight: 16, width: '100%'}}
                                    placeholder='Наименование запчасти'
                                    value={partName}
                                    changeStateValue={value => handleChangeInput('partName', value)}
                                />
                                <Button className={btnCssClass} type='search' id='search-car-by-car-number-btn'
                                        onClick={() => findSearchVehicleByCarNumber(carNumber, carNumberRegion)}/>
                            </div>
                            {failedSearch && (
                                <div className={styles.invalidInputText}>
                                    <div>X Госномер не найден.</div>
                                </div>
                            )}
                        </div>
                    </>
                    : null
            }

        </div>
    );
};
